'use strict';

var React = require('react');

var SvgRefundMinor = function SvgRefundMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15 12h-2v-1c0-.551-.449-1-1-1h-2.586l.586.586a1 1 0 1 1-1.414 1.414l-2.293-2.293a1 1 0 0 1 0-1.414l2.293-2.293a1 1 0 1 1 1.414 1.414l-.586.586h2.586c1.654 0 3 1.346 3 3v1zm2-8.5a1.5 1.5 0 0 0-1.5-1.5h-11a1.5 1.5 0 0 0-1.5 1.5v13.5a1 1 0 0 0 1.3.954c.18-.057.317-.195.439-.338l1.121-1.321 1.349 1.399a1.002 1.002 0 0 0 1.415.026l1.364-1.318 1.305 1.305a.997.997 0 0 0 1.414 0l1.42-1.42 1.136 1.332c.12.141.257.277.434.334a1 1 0 0 0 1.303-.953v-13.5z"
  }));
};

exports.SvgRefundMinor = SvgRefundMinor;
